import { useCallback } from "react";
import { useDispatch } from "react-redux";
import { setDynamicCards as setDynamicDeceasedCards } from "../../store/reducers/deceased.slice";
import { setDynamicCards as setDynamicHospitalCards } from "../../store/reducers/hospital.slice";
import { setDynamicCards as setDynamicAdmissionCards } from "../../store/reducers/admission.slice";
import { setDynamicCards as setDynamicCommunityTransferCards } from "../../store/reducers/community-transfer.slice";
import {
    setDeceasedCards,
    setCommunityTransferCards,
    setHospitalCards,
    setAdmissionCards,
    setOverallCards,
    setDeceasedLayout,
    setCommunityTransferLayout,
    setHospitalLayout,
    setAdmissionLayout,
    setOverallLayout,
} from "../../store/reducers/customCard.slice";

// Function to reset all cards - can be called from Account Selection
export const resetAllCards = (dispatch) => {
    // Reset dynamic cards from individual slices
    dispatch(setDynamicHospitalCards([]));
    dispatch(setDynamicAdmissionCards([]));
    dispatch(setDynamicCommunityTransferCards([]));
    dispatch(setDynamicDeceasedCards([]));

    // Reset all customCard slice values
    dispatch(setDeceasedCards([]));
    dispatch(setCommunityTransferCards([]));
    dispatch(setHospitalCards([]));
    dispatch(setAdmissionCards([]));
    dispatch(setOverallCards([]));
    dispatch(setDeceasedLayout([]));
    dispatch(setCommunityTransferLayout([]));
    dispatch(setHospitalLayout([]));
    dispatch(setAdmissionLayout([]));
    dispatch(setOverallLayout([]));
};

const useResetDynamicCards = () => {
    const dispatch = useDispatch();

    return useCallback(() => {
        // Reset dynamic cards from individual slices
        dispatch(setDynamicHospitalCards([]));
        dispatch(setDynamicAdmissionCards([]));
        dispatch(setDynamicCommunityTransferCards([]));
        dispatch(setDynamicDeceasedCards([]));
        
    }, [dispatch]);
};

export default useResetDynamicCards;